export const verificarSeEhAmbienteDeProducao = () => process.env.REACT_APP_ENV === 'producao';

export const verificarSeEhAmbienteDeHomologacao = () => process.env.REACT_APP_ENV === 'homologacao';

export const consultarNomeNaConsultaDeCpf = () => process.env.REACT_APP_CONSULTAR_NOME_NA_CONSULTA_DE_CPF === 'true';